import React, { useEffect, useState } from 'react';
import './Content.css';
import { getHomedata, getRandomdata } from '../../../api';
import { insert_adv, remove_adv } from '../../../method/adv';
import { iframeLoad } from '../../../method/analytics';

export default function Content({ flag }) {

  const [data, setData] = useState([]);
  const [link, setLink] = useState();
  // const navigate = useNavigate();

  // 判断view是否可以滚动
  // flag ? document.getElementsByTagName("body")[0].style.overflow = 'hidden' : document.getElementsByTagName("body")[0].style.overflow = 'auto';

  const getHomeData = () => {
    getHomedata().then(res => {
      setData(res.data.data);
    })
  }


  /* const goDetails = (para) => {
    // window.history.pushState({page: para}, '', para);
    window.location.href = para;
  } */

  // 随机按钮
  const randomBtn = async () => {
    let target = await getRandomdata().then(res => {
      return res.data.data[Math.floor(Math.random() * res.data.data.length + 1)];
    })
    // window.location = target;
    setLink(target);
  }


  useEffect(() => {
    getHomeData();
    randomBtn();

    if (window.law_ntv_ad1, window.law_ntv_ad2) {
      insert_adv("adv_1");
      insert_adv("adv_2");
      var pageLoadSecond = new Date().getTime();
      iframeLoad(pageLoadSecond);

      return () => {
        remove_adv('adv_1');
        remove_adv('adv_2');
      }
    }
  }, [])


  return (
    <div className='main'>
      {/* 广告一 */}
      <div className='adv_box'>
        <p>Advertisement</p>
        <div id='adv_1' dangerouslySetInnerHTML={{ __html: window.law_ntv_ad1 }}></div>
      </div>

      {/* content */}
      <div className='infor_text'>
        {data.map((item, i) => (
          <div className="ele" key={item.atlid}>
            <a href={item.link} className='btn_a'>
              <div className="tit">
                <div className='num_icon'>{i + 1}</div>
                <strong>{item.title}</strong>
              </div>

              <div className="con">
                <p>{item.digest}</p>
              </div>
            </a>
          </div>
        ))}
      </div>

      <div id="random" onClick={randomBtn}>
        <a href={link} className='btn_a' style={{ color: 'white' }}>R</a>
      </div>

      {/* 广告二 */}
      <div className='adv_box'>
        <p>Advertisement</p>
        <div id='adv_2' dangerouslySetInnerHTML={{ __html: window.law_ntv_ad2 }}></div>
      </div>

    </div>
  )
}
